import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SecurityList from './security-list';
import SecurityForms from './security-forms';
import { paths } from '../../../routes';

const Security = () => (
  <Switch>
    <Route path={paths.security.path} exact>
      <SecurityList />
    </Route>
    <Route path={paths.newSecurity.path}>
      <SecurityForms />
    </Route>
    <Route path={`${paths.security.path}/:reportId`}>
      <SecurityForms />
    </Route>
  </Switch>
);

export default Security;
